export const sitesList = [
    { name: "madrobots.ru", url: "https://madrobots.ru/" },
    { name: "xd-design.ru", url: "https://xd-design.ru/" },
    { name: "picooc.ru", url: "https://picooc.ru/" },
    { name: "petoneer.ru", url: "https://petoneer.ru/" },
    { name: "miku-russia.ru", url: "https://miku-russia.ru/" },
    { name: "chipolo.ru", url: "https://chipolo.ru/" },
    { name: "igarden.store", url: "https://igarden.store/" },
    { name: "ivideon-v.ru", url: "https://ivideon-v.ru/" },
    // { name: "martinelia.ru", url: "https://martinelia.ru/" },
    { name: "bivan.ru", url: "https://bivan.ru/" },
    {
        name: "ledgerwalletrussia.ru",
        url: "https://ledgerwalletrussia.ru/",
    },
    { name: "zavtra.co", url: "https://zavtra.co/" },
];
